<main class="d-flex flex-column justify-content-center align-items-center ">
    <form class="fundo-cartao" [formGroup]="form">
        <h1>Editar agrupamento</h1>
        <div class="p-2">
            <div class="div-input">
                <span>Nome do agrupamento:</span>
                <input formControlName="vc_nome" class="input" type="text">
                <ng-container *ngIf="form.controls.vc_nome.touched">
                    <p class="msg-erro" *ngIf="form.controls.vc_nome.errors">Campo obrigatório *</p>
                </ng-container>
            </div>


            <div class="row mt-3">
                <div class="col">
                    <span>Produto do agrupamento:</span>
                    <select type="number" formControlName="fk_produto" class="input form-control form-control-sm">
                        <option [value]="produto.sr_id" *ngFor="let produto of produtos">
                            {{ produto.vc_nome }}
                        </option>
                    </select>
                    <ng-container *ngIf="form.controls.fk_produto.touched">
                        <p class="msg-erro" *ngIf="form.controls.fk_produto.errors">Campo obrigatório *</p>
                    </ng-container>
                </div>
                <div class="col">
                    <span>Tipo do agrupamento:</span>
                    <select type="number" formControlName="fk_tipo_agrupamento"
                        class="input form-control form-control-sm">
                        <option [value]="tipoAgrupamento.sr_id"
                            *ngFor="let tipoAgrupamento of tiposAgrupamentos; let i = index">
                            {{ tipoAgrupamento.vc_nome_tipo }}
                        </option>
                    </select>
                    <ng-container *ngIf="form.controls.fk_tipo_agrupamento.touched">
                        <p class="msg-erro" *ngIf="form.controls.fk_tipo_agrupamento.errors">Campo obrigatório *</p>
                    </ng-container>
                </div>
            </div>
            <ng-container *ngIf="exibirUsuario">
                <div class="py-2">
                    <app-lista-usuarios (enviaUsuarios)="receberUsuarios($event)" [usuarios]="usuarios"
                        [usuariosVinculadosAoAgrupamento]="usuariosVinculadoAoAgrupamento"></app-lista-usuarios>
                </div>
            </ng-container>
            <ng-container *ngIf="exibirCliente">
                <div class="py-2">
                    <app-lista-clientes (enviaClientes)="receberCliente($event)" [clientes]="clientes"
                        [clientesVinculadosAoAgrupamento]="clientesVinculadoAoAgrupamento"></app-lista-clientes>
                </div>
            </ng-container>
            <ng-container *ngIf="exibirDadosSelecionados">
                <h3 class="mt-3">Usuários selecionados</h3>
                <ul style="max-height: 22vh; overflow: auto;">
                    <li *ngFor="let usuario of usuarios">
                        {{usuario.vc_nome}}
                    </li>
                </ul>
                <h3>Clientes selecionados</h3>
                <ul style="max-height: 22vh; overflow: auto;">
                    <li *ngFor="let cliente of clientes">
                        {{cliente.vc_nome}}
                    </li>
                </ul>
            </ng-container>
        </div>
        <div id="buttons" class="mt-auto p-2 bd-highlight d-flex flex-row justify-content-between row">
            <ng-container *ngIf="exibirDadosSelecionados">
                <button (click)="cancel()" class="btn-cancelar btn btn-lg btn-danger" type="btn">Cancelar</button>
                <button class="btn-sucesso btn btn-lg btn-success" type="submit" [disabled]="!form.valid"
                    (click)="atualizar()">Atualizar</button>
            </ng-container>
        </div>
    </form>
    <div class="load d-flex justify-content-center" *ngIf="loader">
        <mat-progress-spinner diameter=30 class="example-margin" color="primary" mode="indeterminate" value="50">
        </mat-progress-spinner>
    </div>
</main>